import { ApplicationChangerItem } from './application-changer-item';
import { Observable } from 'rxjs/Observable';

export abstract class ApplicationChangerProvider {

  abstract getApplications() : Observable<ApplicationChangerItem[]>;

}
